import React, { useRef, useState } from 'react';
import { IconButton, makeStyles, TextField } from '@material-ui/core';
import { SendFilled } from '@carbon/icons-react';
import { colorSet } from '@components/Provider';

interface CommentInputProps {
  commentRef: React.MutableRefObject<string>;
  inputRef: React.MutableRefObject<HTMLInputElement | null>;
  onAddComment: () => void;
  placeholder: string;
}

const CommentInput: React.FunctionComponent<CommentInputProps> = ({
  commentRef,
  inputRef,
  onAddComment,
  placeholder
}) => {
  const { commentInputStyle } = useStyles();
  const [isValid, setIsValid] = useState<boolean>(false);
  const sendButtonRef = useRef<HTMLButtonElement | null>();

  return (
    <TextField
      placeholder={placeholder}
      className={commentInputStyle}
      variant="outlined"
      fullWidth
      // multiline
      // maxRows={5}
      onKeyPress={(e) => {
        if (sendButtonRef.current && e.key === 'Enter' && !e.shiftKey) {
          sendButtonRef.current.click();
        }
      }}
      onChange={(e) => {
        if (!e.target.value) {
          setIsValid(false);
        } else {
          setIsValid(true);
        }

        let value = e.target.value;

        if (value.length > 5000) {
          value = e.target.value.slice(0, -1);
        }

        commentRef.current = value;
      }}
      inputProps={{
        ref: inputRef,
        maxLength: 5000
      }}
      InputProps={{
        endAdornment: (
          <IconButton
            disabled={!isValid}
            size="small"
            ref={(ref) => (sendButtonRef.current = ref)}
            onClick={() => {
              onAddComment();
              setIsValid(false);
            }}
          >
            <SendFilled
              size={20}
              color={isValid ? colorSet.primary500 : colorSet.gray600}
            />
          </IconButton>
        )
      }}
    />
  );
};

export default CommentInput;

const useStyles = makeStyles(() => ({
  commentInputStyle: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '16px',
      '& .MuiOutlinedInput-input ': {
        padding: () => '12px 0px 12px 16px'
      }
    }
  }
}));
